import { render, staticRenderFns } from "./manage-measurements.vue?vue&type=template&id=0c6882fc"
import script from "./manage-measurements.vue?vue&type=script&lang=js"
export * from "./manage-measurements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports